import { defineStore } from 'pinia';
import { ref } from 'vue';

import iconHorarios01 from '@/assets/images/icons_horarios-01.svg';
import iconHorarios01black from '@/assets/images/icons_horarios-01-black.svg';
import iconHorarios02 from '@/assets/images/icons_horarios-02.svg';
import iconHorarios02black from '@/assets/images/icons_horarios-02-black.svg';
import iconHorarios03 from '@/assets/images/icons_horarios-03.svg';
import iconHorarios03black from '@/assets/images/icons_horarios-03-black.svg';
import iconHorarios04 from '@/assets/images/icons_horarios-04.svg';
import iconHorarios04black from '@/assets/images/icons_horarios-04-black.svg';
import { i18n } from '@/main.js';

import { MenuItem } from "@/models/MenuItem";
import { useEventSearch } from './eventSearch';

interface State {
  currentSelected: MenuItem | null
  searchedId: number | null
}

export const useMenuStore = defineStore({
  id: 'menuStore',
  state: (): State => ({
    currentSelected: null,  // To track the currently selected menu item,
    searchedId: null, // Track the last searched id
  }),
  getters: {
    menuItems() {
      const { t } = i18n.global; 
      const locale = ref(i18n.global.locale.value); 
      const context = import.meta.env.VITE_APP_CONTEXT;
      const cdItem = new MenuItem(1, t('cursodisciplina', locale.value), "curso", iconHorarios01, iconHorarios01black);
      const salaItem = new MenuItem(2, t('sala', locale.value), "sala", iconHorarios02, iconHorarios02black);
      const avalItem = new MenuItem(3, t('avaliacao', locale.value), "avaliacao", iconHorarios03, iconHorarios03black);
      const docItem = new MenuItem(4, t('docente', locale.value), "docente", iconHorarios04, iconHorarios04black);
      if(context == "sidoc"){
        return [cdItem, salaItem, avalItem ];
      }
      return [cdItem, salaItem, avalItem, docItem ];
    }
  },
  actions: {
    selectMenuItem(id) {
      const selectedItem = this.menuItems.find(item => item.id === id);
      const es = useEventSearch();
      const currentOptionIsAvaliacao = this.currentSelected?.id === 3;
      const nextOptionIsAvaliacao = id === 3;
      const nextOptionNotAvaliacao = !nextOptionIsAvaliacao;
      if(currentOptionIsAvaliacao && nextOptionNotAvaliacao){
        es.updateMonthlyDateToWeeklyDate();
      }else if(nextOptionIsAvaliacao){
        es.updateWeeklyDateToMonthlyDate();
      }
      if (selectedItem) {
        this.currentSelected = selectedItem;
      }
      if(id == null){
        this.currentSelected = null;
      }
    }
  }
});
